import React from 'react';
import { Spin } from 'antd';

export default () => <div style={{textAlign: 'center', padding: '30px 50px'}}><Spin /></div>;